import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Button, Box } from "@material-ui/core";
import ErrorImage from "../../images/404.png";
import DarkenBackground from "../base/DarkenBackground";
import { navigate } from "@reach/router";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: "100vh",
    padding: theme.spacing(2.5),
    boxSizing: "border-box",
    background: `url(${ErrorImage})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    color: theme.palette.grey[100],
    display: "flex",
    alignItems: "stretch",
  },
  contentContainer: {
    zIndex: "1",
    display: "flex",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  title: {
    marginTop: theme.spacing(15),
  },
  subtitle: {
    marginTop: theme.spacing(2),
  },
  selection: {
    marginBottom: theme.spacing(5),
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    color: theme.palette.grey[100],
  },
}));

export default function ErrorPage() {
  const classes = useStyles();

  return (
    <>
      <DarkenBackground />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.title}>
            <Box variant="h5" fontWeight="fontWeightBold" style={{ fontSize: "400%" }}>
              404
            </Box>
            <Box variant="h5" fontWeight="fontWeightBold" style={{ fontSize: "200%" }}>
              Außer Atem?
            </Box>
            <Typography variant="h6" className={classes.subtitle} style={{ fontSize: "125%" }}>
              Hoffentlich nicht. Hier geht es auf jeden Fall nicht weiter.
            </Typography>
          </div>
          <div className={classes.selection}>
            <div className={classes.buttons}>
              <Button
                variant="outlined"
                color="inherit"
                fullWidth={true}
                className={classes.button}
                onClick={() => navigate("/stationen")}
              >
                zu den Stationen
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
